import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { MaintenanceService } from '../services/maintenance.service';
import { MaintenanceUtilities, SUPPRESS_MAINTENANCE_REDIRECT } from '../utilities/maintenance.utilities';

/**
 * Routes the user to the maintenance page when any API call comes back as maintenance.
 *
 * The error still propagates: callers keep their own failure handling, and the maintenance page is
 * shown over whatever they do with it.
 */
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private readonly maintenanceService = inject(MaintenanceService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (MaintenanceUtilities.isMaintenanceResponse(error)
          && !request.context.get(SUPPRESS_MAINTENANCE_REDIRECT)) {
          this.maintenanceService.enterMaintenance();
        }

        return throwError(() => error);
      })
    );
  }
}
